import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.partner)?_c(VImg,_vm._b({attrs:{"src":_vm.partner.logo}},'v-img',_vm.$attrs,false)):_c(VImg,_vm._b({attrs:{"src":"https://parked.blob.core.windows.net/ownli/www/logos/logo.png"}},'v-img',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }